import React from 'react';
import Hero from './components/sustainability/Hero';
import Main from './components/sustainability/Main';

const Sustainability = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Sustainability;